export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_771_MY_PERFORMANCE': 'My Performance',
    '_830_DAY': 'Day',
    '_829_WEEK': 'Week',
    '_828_MONTH': 'Month',
    '_9603_OTHER': 'Other',
    '_9924_SELECT_THE_DAY': 'Select the day',
    '_9925_SELECT_THE_WEEK': 'Select the week',
    '_9926_SELECT_THE_MONTH': 'Select the month',
    '_9927_OPEN_THIS_SELECT_WEEK': 'Open this select week',
    '_9928_OPEN_THIS_SELECT_MONTH': 'Open this select month',
    '_9929_COMPARE': 'Compare',
    '_832_MARKET': 'Market',
    '_64_SITE': 'Site',
    '_9930_AREA_LOB': 'Area LOB',
    '_9931_REGION_LOB': 'Region LOB',
    '_9932_TEAM_SUPER_GROUP': 'Team SuperGroup',
    '_148_AREA': 'Area',
    '_149_REGION': 'Region',
    '_656_USER': 'User',
    '_9933_SITE_LOB': 'Site LOB',
    '_583_LOB': 'LOB',
    '_9934_USER_QUEUE': 'User Queue',
    '_9935_SUPER_GROUP_QUEUE': 'SuperGroup Queue',
    '_9936_SITE_SUPER_GROUP_QUEUE': 'Site SuperGroup Queue',
    '_824_PEER_GROUP': 'PeerGroup',
    '_67_SUPER_GROUP': 'SuperGroup',
    '_9937_SITE_PEER_GROUP': 'Site PeerGroup',
    '_9938_SITE_SUPER_GROUP': 'Site SuperGroup',
    '_9939_USER_SUPER_GROUP': 'User SuperGroup',
    '_9940_AREA_PEER_GROUP': 'Area PeerGroup',
    '_9941_REGION_SUPER_GROUP': 'Region SuperGroup',
    '_9918_PEER_COMPARE': 'Peer Compare',
    '_9942_PERIOD_COMPARE': 'Period Compare',
    '_10059_POPULATION_COMPARE': 'Population Compare',
    '_9943_LAUNCH_RADIAL': 'Launch Radial',
    '_9944_BLANK': 'Blank',
    '_9945_TOTAL_PERFORMANCE': 'Total Performance',
    '_725_ACTUAL': 'Actual',
    '_7339_METRIC_NAME': 'Metric Name',
    '_726_TARGET': 'Target',
    '_721_GOAL': 'Goal',
    '_11172_NO_RESULTS_TO_DISPLAY': 'No results to display',
    '_11173_NO_TARGET_THRESHOLDS_CONFIGURED': 'No target/thresholds configured',
    '_11178_VIEW_PILLAR_METRICS': 'View Pillar Metrics',
    '_11179_VIEW_ALL_METRICS': 'View All Metrics',
    '_11180_EXPAND_ALL_PILLARS': 'Expand All Pillars',
    '_11181_COLLAPSE_ALL_PILLARS': 'Collapse All Pillars',
    '_11182_EXPAND_PILLAR': 'Expand Pillar',
    '_11183_COLLAPSE_PILLAR': 'Collapse Pillar',
    '_11174_RESET_CARD': 'Reset Card',
    '_11175_COLLAPSE_CARD': 'Collapse Card',
    '_11176_EXPAND_CARD': 'Expand Card',
    '_989_TREND': 'Trend',
    '_10075_VIEW_TREND': 'View Trend',
    '_10091_EXPAND_ROW': 'Expand Row',
    '_10092_COLLAPSE_ROW': 'Collapse Row',
    '_763_CLOSE': 'Close',
    '_11217_FULLSCREEN': 'Fullscreen',
    '_11218_REDUCE': 'Reduce',
    '_11219_GO_BACK': 'Go Back',
    '_11220_GO_FORWARD': 'Go Forward',
    '_657_SELECT_A_USER': 'Select a User'

};
